"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessTokenManagerAsync = void 0;
var runtypes_1 = require("runtypes");
var ExpJwt = (0, runtypes_1.Record)({ exp: runtypes_1.Number });
var AccessTokenManagerAsync = /** @class */ (function () {
    function AccessTokenManagerAsync(getNewAccessToken, leeway) {
        if (leeway === void 0) { leeway = 30 * 1000; }
        this.getNewAccessToken = getNewAccessToken;
        this.leeway = leeway;
    }
    AccessTokenManagerAsync.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this.setAccessToken;
                        return [4 /*yield*/, this.getNewAccessToken()];
                    case 1:
                        _a.apply(this, [_b.sent()]);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        console.error("Failed to refresh access token", e_1);
                        throw e_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AccessTokenManagerAsync.prototype.getAccessToken = function () {
        var _a;
        if (this.expiresAt == null || this.expiresAt < Date.now()) {
            /**
             * This function has to be synchronous, but at least we can commence a refresh so
             * that we hopefully have a valid token the next time the client tries to reconnect.
             */
            this.init().catch();
        }
        return (_a = this.accessToken) !== null && _a !== void 0 ? _a : "";
    };
    AccessTokenManagerAsync.prototype.setAccessToken = function (accessToken) {
        var _this = this;
        // Parse the JWT and extract the exp claim.
        var exp = ExpJwt.check(JSON.parse(Buffer.from(accessToken.split(".")[1], "base64").toString())).exp;
        this.accessToken = accessToken;
        this.expiresAt = exp * 1000;
        var refreshAfter = this.expiresAt - Date.now() - this.leeway;
        setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.init()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }, Math.max(refreshAfter, 1000));
    };
    return AccessTokenManagerAsync;
}());
exports.AccessTokenManagerAsync = AccessTokenManagerAsync;
//# sourceMappingURL=AccessTokenManagerAsync.js.map